export default function RaysEyeSection() {
  return (
    <section id="rayseye" className="section-wrap bg-gray-900">
      <div className="page-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div>
              <p className="text-orange-500 text-lg font-medium mb-2">Audio video annotation tool</p>
              <h2 className="section-title">
                RaysEye
              </h2>
            </div>

            <p className="text-gray-300 text-lg leading-relaxed">
              <span className="text-orange-500 font-semibold">RaysEye</span>, a simple yet powerful video
              annotation tool, is RAYS SPORTS's exclusive solution for
              sports analysis. The tool enables video analysis
              and can be used for annotating, measuring, and
              capturing performances.
              <br /><br />
              It can also extend its utility beyond sports and
              can bring value to scientific and fine arts
              performances.
            </p>

            <button className="group bg-orange-500 hover:bg-orange-600 text-black font-semibold px-8 py-4 rounded-full transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer">
              <span className="relative z-10 flex items-center">
                See how it works
                <i className="ri-arrow-right-line ml-2"></i>
              </span>
            </button>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-xl shadow-2xl">
              <img
                src="/images/rayseye-annotation-interface.png"
                alt="RaysEye video annotation interface"
                className="w-full h-auto hover:scale-105 transition-transform duration-500 cursor-pointer"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
            
            {/* Floating Elements */}
            <div className="absolute -top-4 -right-4 w-8 h-8 bg-orange-500 rounded-full animate-pulse"></div>
            <div className="absolute -bottom-4 -left-4 w-6 h-6 bg-white rounded-full animate-bounce"></div>
          </div>
        </div>
      </div>
    </section>
  );
}